
<div class="page-container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="60px">
    <div fxLayoutAlign="center center">
        <img  fxFlex='40'   alt="Logo" src="./assets/img/brand/{{brand}}/logo_big.png">
    </div>
   
    <div fxLayout="row" fxLayoutAlign="center center" >
        <div class="info-box" fxLayout="column" fxFlex='80'>
            <div>
                <strong class="error-label">{{ 'errors.userIsNotAuthorizedToThisPage' | translate}}</strong>
            </div>

            <button class="page-button" kendoButton (click)="homePage()">{{'global.goBackToHomePage' | translate}}</button>
            <button class="page-button" kendoButton (click)="logout()">{{'layout.topToolbarLogout' | translate}}</button>

            <!-- <div fxFlex='row' fxLayoutAlign="center center">
                <button class="page-button" type="button" (click)="goToLoginPage()">{{ 'global.goToLoginPage' | translate}}</button>
            </div> -->
           
        </div>
    </div>
  
</div>


